import type { InputCalendarProps } from './InputCalendar';
import InputCalendar from './InputCalendar';

export default InputCalendar;
export type { InputCalendarProps };
